import { FormatDateTime, FormatNumber} from '@/Helpers/Format';

export default {
    data() {
        return {
            shipment_number: '',
            change_branch: {},
            shipment_detail: {},
            loading: true,
            listAllOrders: {},
            // Value
            selectedAllStatus: null,
            searchItem: '',
            shipment: {},
            oldVal: '',
            //LA_Status
            la_status: {
                'Pending': this.$t('common.Pending'),
                'Processing': this.$t('common.Processing'),
                'Delivering': this.$t('common.Delivering'),
                'Success': this.$t('common.Success'),
                'Single Sign': this.$t('common.Single Sign'),
                'Timeout': this.$t('common.Timeout'),
                'Contact Error': this.$t('common.Contact Error'),
                'Lost': this.$t('common.Lost'),
                'Return To Sender': this.$t('common.Return To Sender'),
                'Address Error': this.$t('common.Address Error'),
                'Trouble': this.$t('common.Trouble'),
                'Disposed': this.$t('common.Disposed'),
                'Customer Request Cancel': this.$t('common.Customer Request Cancel'),
                'Wrong Flow': this.$t('common.Wrong Flow'),
                'Expires': this.$t('common.Expires'),
                'BillWasSettled': this.$t('ລາຍການOrderພັດສະດຸ.ຮຽກເກັບເງິນສຳເລັດແລ້ວ'),
                'SuccessfullyCompensated': this.$t('ລາຍການOrderພັດສະດຸ.ຊົດເຊີຍເງິນສຳເລັດ'),
                'BlockSignShipment': this.$t('common.BlockSignShipment')
            },

            la_status_shipment_type: {
                'origin_freight_fees': this.$t('common.origin_freight_fees'),
                'destination_freight_fees': this.$t('common.destination_freight_fees'),
                'origin_freight_fees_cod': this.$t('common.origin_freight_fees_cod'),
                'destination_freight_fees_cod': this.$t('common.destination_freight_fees_cod'),
                'all': this.$t('common.all')
            }
        };
    },
    methods: {
        FormatDate(value) {
            return FormatDateTime(value);
        },

        FormatPrice(price) {
            if (price !== 0) {
                return FormatNumber(price, ' ' + this.$t('common.ກີບ'));
            }
            return 0 + ' ' + this.$t('common.ກີບ');
        },

        // Removed fetchInvoiceItemsResponse and FetchData - now handled in component for pagination support

        BtnLoading() {
            return this.$vs.loading({
                target: this.$refs.table,
                scale: "1",
                background: "primary",
                opacity: 1,
                color: "#195BFF",
            });
        },
    },
}
